import React from "react";
import LinkItem from "../Helpers/LinkItem";

const Template1 = ({
  profileImage,
  backgroundImage,
  bio,
  profileName,
  profilePosition,
  profileColor,
  links,
  email,
}) => {
  return (
    <div className="bg-green-50 min-h-screen flex items-center justify-center text-gray-900">
      <div
        className="relative border shadow-lg rounded-xl bg-cover bg-center w-[375px] h-[812px]"
        style={{
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none",
        }}
      >
        <div
          className={`h-full p-6 ${
            profilePosition ? `text-${profilePosition}` : "text-left"
          }`}
        >
          {/* Conditional rendering for profile image */}
          {profileImage && (
            <img
              src={profileImage}
              alt="Profile"
              className="w-24 h-24 rounded-full mx-auto mb-4 border-4 border-white shadow-md"
            />
          )}

          {/* Conditional rendering for profile name */}
          {profileName && (
            <h1
              className="text-2xl font-extrabold tracking-wide"
              style={{ color: profileColor || "#333" }}
            >
              {profileName}
            </h1>
          )}

          {/* Conditional rendering for email */}
          {email && (
            <p className="text-sm text-gray-600 mt-2 italic">{email}</p>
          )}

          {/* Conditional rendering for bio */}
          {bio && (
            <p className="text-md mt-4 font-light" style={{ color: "#4a5568" }}>
              {bio}
            </p>
          )}

          {/* Conditional rendering for links */}
          {links && links.length > 0 && (
            <div className="mt-6 space-y-4">
              {links.map((link) => (
                <LinkItem key={link.id} link={link} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Template1;
